import React from 'react';
import RestoreIcon from '@material-ui/icons/Restore';
import { Permissions, userHasPermission } from 'services/Authorization';
import strings from 'strings';
import { FPButtonMenu } from 'UI/components/molecules';

import { RESCHEDULE_MODES } from '../RescheduleActionsDialog/RescheduleActionsDialog.constants';

export const RescheduleActionsButton = ({ selectedItems, onOpenRescheduleDialog = () => {} }) => {
  const actionItems = [
    {
      action: () => onOpenRescheduleDialog(RESCHEDULE_MODES.Tomorrow),
      title: strings.dailyPlan.rescheduleActions.rescheduleOptions.rescheduleForTomorrow.title,
      visible: true
    },
    {
      action: () => onOpenRescheduleDialog(RESCHEDULE_MODES.Custom),
      title: strings.dailyPlan.rescheduleActions.rescheduleOptions.customReschedule.title,
      visible: true
    }
  ];

  if (!userHasPermission(Permissions.DailyPlan.CanUseModule) || !selectedItems.data?.length)
    return null;

  return (
    <FPButtonMenu
      data-testid="reschedule-actions-btn"
      icon={RestoreIcon}
      isIconButton
      IconButtonProps={{
        iconProps: {
          onSetColor: ({ primary }) => primary.main
        }
      }}
      menuItems={actionItems}
      tooltipProps={{
        arrow: false,
        placement: 'bottom',
        title: strings.dailyPlan.tableAction.reschedule
      }}
    />
  );
};
